import { css } from "../../../../../styled-system/css";
import { t } from "../../../../libs/i18n";
import { Heading } from "./heading";

export const MarumoriCampaignDetail = () => {
  return (
    <div
      className={css({
        display: "flex",
        flexDirection: "column",
        gap: "36px",
      })}
    >
      <div
        className={css({
          display: "flex",
          flexDirection: "column",
          gap: "12px",
        })}
      >
        <Heading>{t("まるもり地域ポイント抽選について")}</Heading>
        <p
          className={css({
            fontSize: "16px",
            lineHeight: "1.5",
            letterSpacing: "0.16px",
            color: "text.primary",
          })}
        >
          {t(
            "まるもり地域ポイント2,000円分を1,000名の方にプレゼントします。当選者にはまるもり地域ポイントが即時付与され、丸森町内の取扱店で利用できます。",
          )}
          <br />
          {t(
            "初回抽選で落選した場合でも、令和8年1月末の再抽選で当選するチャンスがあります。",
          )}
        </p>
      </div>

      <div
        className={css({
          display: "flex",
          flexDirection: "column",
          gap: "12px",
        })}
      >
        <Heading>{t("応募の方法")}</Heading>
        <div
          className={css({
            display: "flex",
            flexDirection: "column",
            gap: "24px",
          })}
        >
          <div
            className={css({
              display: "flex",
              flexDirection: "column",
              gap: "12px",
            })}
          >
            <h3
              className={css({
                fontSize: "16px",
                fontWeight: "700",
                lineHeight: "1.5",
                letterSpacing: "0.16px",
                color: "text.primary",
              })}
            >
              {t("STEP1：応募ボタンをタップ")}
            </h3>
            <p
              className={css({
                fontSize: "16px",
                lineHeight: "1.5",
                letterSpacing: "0.16px",
                color: "text.primary",
              })}
            >
              {t(
                "「まるもりポイント」アプリのホーム画面から、「応募する」ボタンを押します。",
              )}
            </p>
          </div>

          <div
            className={css({
              display: "flex",
              flexDirection: "column",
              gap: "12px",
            })}
          >
            <h3
              className={css({
                fontSize: "16px",
                fontWeight: "700",
                lineHeight: "1.5",
                letterSpacing: "0.16px",
                color: "text.primary",
              })}
            >
              {t("STEP2：抽選スタート")}
            </h3>
            <p
              className={css({
                fontSize: "16px",
                lineHeight: "1.5",
                letterSpacing: "0.16px",
                color: "text.primary",
              })}
            >
              {t("当選した方にはまるもり地域ポイントが付与されます。")}
              <br />
              {t(
                "外れた方にも再抽選のチャンスがあります。（令和8年1月末実施）",
              )}
            </p>
          </div>
        </div>
      </div>

      <div
        className={css({
          display: "flex",
          flexDirection: "column",
          gap: "12px",
        })}
      >
        <Heading>{t("スケジュール")}</Heading>
        <ul
          className={css({
            listStyleType: "disc",
            paddingLeft: "24px",
            fontSize: "16px",
            lineHeight: "1.5",
            letterSpacing: "0.16px",
            color: "text.primary",
          })}
        >
          <li>{t("令和7年9月1日：抽選期間開始")}</li>
          <li>{t("令和7年10月1日：利用期間開始")}</li>
          <li>{t("令和7年12月31日：抽選期間終了")}</li>
          <li>{t("令和8年1月末：再抽選実施")}</li>
          <li>{t("令和8年2月28日：利用期間終了")}</li>
        </ul>
      </div>

      <div
        className={css({
          display: "flex",
          flexDirection: "column",
          gap: "12px",
        })}
      >
        <Heading>{t("キャンペーン注意事項")}</Heading>
        <ul
          className={css({
            listStyleType: "disc",
            paddingLeft: "24px",
            fontSize: "16px",
            lineHeight: "1.5",
            letterSpacing: "0.16px",
            color: "text.primary",
          })}
        >
          <li>
            {t(
              "応募は1人1回限りです。令和6年度にポイントを受領した方は対象外です。",
            )}
          </li>
          <li>
            {t(
              "令和8年1月31日に再抽選を実施します。結果はアプリでお知らせします。",
            )}
          </li>
          <li>
            {t(
              "まるもり地域ポイントミニアプリを削除した場合、抽選への参加資格を失います。",
            )}
          </li>
        </ul>
      </div>
    </div>
  );
};
